export default __webpack_public_path__ + "static/media/Rastech-update-4.3739e159.jpg";